import { css } from 'emotion';

const root = () => css`
  position: relative;
  height: 100%;
`;

const overlay = theme => css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.color.white};
  opacity: 0.5;
`;

export default {
  root,
  overlay
};
